import { environment } from '@environment/environment'

type CurrencyType = '₹' | '$' | '€'

export const currency: CurrencyType = '$'

export const currentYear = new Date().getFullYear()

export const credits = {
  website: 'https://sphynch.com/',
  name: 'Sphynch',
  platformName: 'Provision',
}

export const gridPageSizes = [5,10,25,50]
export const gridDefaultPageSize = 10

export const basePath: string = '/'

export const apiSettings = {
  // Environment-driven (see src/environments/*): absolute localhost for local dev, '' (same-origin) for the
  // azure build so API calls are relative `/api/v1/...` and resolve through the nginx edge. One code path.
  baseApiUrl: environment.apiBaseUrl,
  ecommerceApiUrl: environment.ecommerceApiBaseUrl,
  baseApiVersion: 'api/v1',
  ecommerceApiVersion: 'api/v1',
  fallbackErrorMessage: 'An unhandled exception occured.',
}

export const OAuthSettings = {
  // Issuer is environment-driven (see src/environments/*) so local debugging and the Azure deployment
  // share one code path — switch with `ng serve --configuration azure`.
  issuer: environment.oauthIssuer,
  redirectUriPath: '',
  clientId: '26A30742-7363-4294-9EDD-C23FBEA77EC8',
  scope: 'openid profile offline_access provision_api',
  responseType: 'code',
  // 'remoteOnly': a remote Identity server must be HTTPS, but a localhost redirect/issuer may stay HTTP.
  requireHttps: 'remoteOnly' as const,
}
